import React, { createContext, useContext, useState, useCallback } from 'react';

interface MenuCollapseContextType {
  isCollapsed: boolean;
  toggleCollapse: () => void;
}

const MenuCollapseContext = createContext<MenuCollapseContextType>({
  isCollapsed: false,
  toggleCollapse: () => {},
});

export const useMenuCollapse = () => useContext(MenuCollapseContext);

export const MenuCollapseProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  const toggleCollapse = useCallback(() => {
    setIsCollapsed((prev) => !prev);
  }, []);

  return (
    <MenuCollapseContext.Provider value={{ isCollapsed, toggleCollapse }}>
      {children}
    </MenuCollapseContext.Provider>
  );
};
